/**
 * Piletilevi Sales terminal services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Event state machine | PUBLISH - Assign \'ON_SALE\' status to Event or create Event Approval request in case of PUBLIC venue. Can be used by \'DRAFT\' or \'SALE_STOPPED\' Events. STOP_SALE - Assign \'SALE_STOPPED\' status to Event with Reasoning. Can be used by \'ON_SALE\' Events. POSTPONE - Move Event \'eventStart/End\' to \'postponedStart/End\'. Can be used by \'SALE_STOPPED\' events.
 */
export type EventAction = 'PUBLISH' | 'STOP_SALE' | 'POSTPONE' | 'CANCEL';

export const EventAction = {
    Publish: 'PUBLISH' as EventAction,
    StopSale: 'STOP_SALE' as EventAction,
    Postpone: 'POSTPONE' as EventAction,
    Cancel: 'CANCEL' as EventAction
};

